<script>
  import { parsePercent, parseNumber } from "../Common/tools";
  import RowApproveDeny from "../Contacts/Common/RowApproveDeny.svelte";
  import {External, M} from "../external";

  export let data = {},
    activeColumns = [],
    selection,
    tableType,
    onClick,
    hasCheckbox = true,
    idField;
  let columnCache = {},
    instance,
    checked = false;

  let name = External.Tools.escapeIfNeeded(data["col0"]) || External.Tools.escapeIfNeeded(data["name"]) || "";
  let email = activeColumns.length > 1 && activeColumns[1].isEmailColumn ? data["col1"] || "" : External.Tools.escapeIfNeeded(data["email"]) || ""; // only if the second column is email
  let userData = External.Tools.getColorAndInitialsFromNameAndEmail(name, email);
  userData.color = "background-color: " + userData.color;

  function getDate(col) {
    return External.Tools.dateToString(new Date(data[col]), false);
  }

  function render(col, idx) {
    let cache = columnCache[col];
    let property = cache || External.getById(External.Website.crmProperties, col);

    if (!cache && property) {
      columnCache[col] = property;
    }

    if (property) {
      let value = data["col" + idx];
      if (property.type === External.CRM_PROPERTY_TYPE.DATE) {
        if (External.WebPlatform.parse(value, 0) > 0) value = External.Tools.dateToStr(new Date(+value * 1000), External.WebsiteSettings.getDateFormat());
        else value = "";
      } else if (property.type === External.CRM_PROPERTY_TYPE.COUNTRY) {
        value = External.COUNTRIES[External.COUNTRY_CODES.indexOf(value)] || value;
      }

      let clz = "flex-none";
      if (property.id === -2) {
        email = data["col" + idx];
        clz = "flex-1";
      }

      return {
        clz: clz,
        value: External.Tools.escapeIfNeeded(value) || ""
      };
    }

    return null;
  }

  function onSelect(e) {
    let checked = e.target.checked;

    if (selection && selection.all) {
      let idx = selection.unselected.indexOf(data.id);
      if (checked && idx > -1) selection.unselected.splice(idx, 1);
      else if (!checked && idx < 0) selection.unselected.push(data.id);
    } else {
      if (checked) {
        if (selection === null) {
          selection = {
            all: false,
            selected: [],
            unselected: []
          };
        }
        if (selection.selected.indexOf(data[getIdField()]) < 0) selection.selected.push(data[getIdField()]);
      } else if (selection !== null) {
        let idx = selection.selected.indexOf(data[getIdField()]);
        if (idx >= 0) selection.selected.splice(idx, 1);
        if (selection.selected.length === 0) selection = null;
      }
    }
  }

  function parseOutput(row, column) {
    const value = row[column.key];
    switch (column.type) {
      case "number":
        return parseNumber(value);
      case "percent":
      case "progressbar":
        return parsePercent(value);
      default:
        return value === null ? "" : value;
    }
  }

  function onTooltipClick(column) {
    let target = External.$(instance);

    let items = typeof column.items === "function" ? column.items(data) : column.items;
    if (!items.length) {
      return;
    }

    External.Tools.showTooltipOptions(target, items, function (target, idx, text, tag) {
      column.action(data.id, tag, data);
    });
  }

  function getRowLabel(data, column) {
    if (typeof column.rowLabel === "function") {
      return column.rowLabel(data, column);
    }
    return column.rowLabel + " " + data[column.row];
  }

  function getRowClass(data, column) {
    if (typeof column.rowClass === "function") {
      return column.rowClass(data, column);
    }
    return column.rowClass || "";
  }

  function getTags(row, column) {
    let tags = column.tags;

    if (typeof tags === "function") tags = column.tags(row, column);

    if (!tags || !tags.length) return false;

    for (let i = 0; i < tags.length; i++) {
      if (row[tags[i].key]) {
        return tags[i].label;
      }
    }

    return false;
  }

  let click = (event, column) => {
    if (column.onClick) {
      column.onClick(data, column, event.target);
    } else {
      onClick(data);
    }
  };

  let getIdField = () => {
    return idField === undefined ? 'id' : idField;
  }

  $: checked = selection != null &&
    ((selection.selected && selection.selected.indexOf(data[getIdField()]) !== -1) ||
            (selection.all && selection.unselected && selection.unselected.indexOf(data[getIdField()]) === -1) ||
            (selection.all && (selection.unselected == null || selection.unselected.length === 0)));


</script>

<tr class="flex flex-row align-center" data-id={data[getIdField()]}>
  {#if tableType === "contacts"}
    <td class="checkbox-table">
      <div class="checkbox-wrapper small">
        <input id="rowcbx{data[getIdField()]}" class="css-checkbox select-cbx" type="checkbox" name="rowcbx{data[getIdField()]}" on:change={onSelect} bind:checked />
        <label for="rowcbx{data[getIdField()]}" class="css-label">&nbsp;</label>
      </div>
    </td>
    <td class="flex-1">
      <a rel="tab" href="/me/crm/contact/{data[getIdField()]}">
        <div class="personal-icon" style={userData.color}>{userData.initials}</div>
        {name}
      </a>
    </td>
    {#each activeColumns as col, idx (col)}
      {#if col === "registered" || col === "created"}
        <td class="flex-none"><a rel="tab" href="/me/crm/contact/{data[getIdField()]}">{getDate(col)}</a></td>
      {:else if col === "status"}
        <td class="flex-none">
          {#if data.status}
            {M.APPROVED}
          {:else}
            <RowApproveDeny />
          {/if}
        </td>
      {:else if col === "tags"}
        <td class="flex-none">{External.Tools.escapeIfNeeded(data.tags) || M.NONE.toLowerCase()}</td>
      {:else if col === -1}{:else if render(col, idx) != null}
        <td class={render(col, idx).clz}>
          <a rel="tab" href="/me/crm/contact/{data[getIdField()]}">
            {render(col, idx).value}
          </a>
        </td>
      {/if}
    {/each}
  {:else}
    {#if hasCheckbox}
      <td class="checkbox-table">
        <div class="checkbox-wrapper small">
          <input id={data[getIdField()]} class="css-checkbox select-cbx" on:change={onSelect} type="checkbox" name={data[getIdField()]} bind:checked />
          <label for={data[getIdField()]} class="css-label">&nbsp;</label>
        </div>
      </td>
    {/if}
    {#each activeColumns as column, i (column)}
      {#if column.type === "action"}
        <td class={column.class} bind:this={instance}>
          <a on:click={() => onTooltipClick(column)}><span class="material-icons-outlined"> settings </span></a>
        </td>
      {:else if column.type === "progressbar"}
        <td class={column.class}>
          <div class="table-bar-outer">
            <div class="table-bar" style={"width: " + parseOutput(data, column)} />
            <span class="table-bar-label">{parseOutput(data, column)}</span>
          </div>
        </td>
      {:else if column.type === "icon"}
        <td class:none={column.showWhenTruthy && !data[column.key]} class={column.class} bind:this={instance}>
          <a alt={column.alt || ''} on:click={() => column.onClick(data, column)}><span class={column.iconClass}> {column.iconText} </span></a>
        </td>
      {:else if column.type === "approve_deny"}
        <td class="flex-none">
          {#if data.status}
            {M.APPROVED}
          {:else}
            <RowApproveDeny approveClick={()=> {column.approve(data, column)}} denyClick={()=> {column.deny(data, column)}} />
          {/if}
        </td>
      {:else if column.row}
        <td class={column.class} style={column.style ? column.style : "font-size: 17px;"} on:click={(event) => click(event, column)}>
          <b>{parseOutput(data, column)}</b>
          {#if !getTags(data, column)}
            <p class="table-support-text">{getRowLabel(data, column)}</p>
          {:else}
            <span class="draft-status">{getTags(data, column)}</span>
          {/if}
        </td>
      {:else}
        <td class={column.class} style={column.style} on:click={(event) => click(event, column)}>
          {#if column.rowClasses}
            {#if column.rowClasses[column.rowClassConditions.indexOf(parseOutput(data, column))]}
              <span class={column.rowClasses[column.rowClassConditions.indexOf(parseOutput(data, column))]}>
                {parseOutput(data, column)}
              </span>
            {:else}
              <span class={getRowClass(data, column)}>
                {parseOutput(data, column)}
              </span>
            {/if}
          {:else if column.rowClass}
            <span class={getRowClass(data, column)}>
              {parseOutput(data, column)}
            </span>
          {:else if (column.key === "name" || column.isNameColumn) && !column.disableNameInitials}
            <div class="personal-icon" style={userData.color}>{userData.initials}</div>
            {parseOutput(data, column)}
          {:else if column.type !== "image"}
            {parseOutput(data, column)}
          {:else}
            <img class={column.imageClass || "campaign-thumb-img"} src={parseOutput(data, column)} alt="" />
          {/if}
          {#if column.suffix}
            {@html column.suffix(data, column)}
          {/if}
        </td>
      {/if}
    {/each}
  {/if}
</tr>
